import { defineComponent as F, computed as i, ref as x, watch as U, useId as T, createBlock as q, createCommentVNode as C, openBlock as h, unref as a, withCtx as r, createVNode as n, createSlots as A, createElementVNode as b, createElementBlock as V, renderSlot as k, toDisplayString as G } from "vue";
import { ScalarCard as W, ScalarCardHeader as J, ScalarCombobox as P, ScalarButton as Q, ScalarCardSection as j, ScalarCodeBlock as X, ScalarCardFooter as Y } from "@scalar/components";
import { freezeElement as Z } from "@scalar/helpers/dom/freeze-element";
import { ScalarIconCaretDown as _ } from "@scalar/icons";
import { operationToHar as ee } from "@scalar/oas-utils/helpers/operation-to-har";
import { emitCustomEvent as w } from "@scalar/workspace-store/events";
import { getResolvedRef as te } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { getResolvedRefDeep as E } from "../../../../features/example-responses/helpers/get-resolved-ref-deep.js";
import { findClient as L } from "../helpers/find-client.js";
import { generateCustomId as O } from "../helpers/generate-client-options.js";
import { generateCodeSnippet as le } from "../helpers/generate-code-snippet.js";
import { getSecrets as oe } from "../helpers/get-secrets.js";
import ae from "./ExamplePicker.vue2.js";
import R from "../../../../components/HttpMethod/HttpMethod.vue.js";
const se = ["innerHTML"], ne = { class: "text-base font-normal" }, re = ["id"], ue = {
  key: 0,
  class: "request-card-footer-addon"
}, ie = { class: "request-header" }, ce = {}, $e = /* @__PURE__ */ F({
  ...ce,
  __name: "RequestExample",
  props: {
    clientOptions: {},
    selectedClient: {},
    selectedServer: { default: () => ({ url: "/" }) },
    selectedContentType: {},
    selectedExample: {},
    securitySchemes: { default: () => [] },
    method: {},
    path: {},
    operation: {},
    fallback: { type: Boolean },
    generateLabel: { type: Function },
    isWebhook: { type: Boolean }
  },
  setup(l) {
    const c = i(() => {
      var s, f;
      const e = ((s = te(l.operation.requestBody)) == null ? void 0 : s.content) ?? {}, t = l.selectedContentType || Object.keys(e)[0];
      return ((f = e[t]) == null ? void 0 : f.examples) ?? {};
    }), v = x(
      l.selectedExample ?? Object.keys(c.value)[0]
    ), g = i(() => [
      "x-custom-examples",
      "x-codeSamples",
      "x-code-samples"
    ].flatMap((t) => l.operation[t] ?? [])), p = i(() => g.value.length ? [
      {
        label: "Code Examples",
        options: g.value.map((t) => {
          const o = O(t), s = t.label || t.lang || o;
          return {
            id: o,
            lang: t.lang || "plaintext",
            title: s,
            label: s
          };
        })
      },
      ...l.clientOptions
    ] : l.clientOptions), u = x(
      L(p.value, l.selectedClient) ?? null
    );
    U(
      () => l.selectedClient,
      (e) => {
        const t = L(p.value, e);
        t && (u.value = t);
      }
    );
    const y = i(() => {
      if (!l.isWebhook) return null;
      try {
        const e = c.value[v.value || ""], t = E(e), o = (t == null ? void 0 : t.value) ?? (t == null ? void 0 : t.summary);
        return ee({ operation: l.operation, method: l.method, path: l.path, example: o });
      } catch (e) {
        return console.error("[webhookHar]", e), null;
      }
    }), $ = i(() => {
      var e, t, o, s, f;
      try {
        if ((e = u.value) != null && e.id.startsWith("custom"))
          return ((t = g.value.find(
            (M) => {
              var B;
              return O(M) === ((B = u.value) == null ? void 0 : B.id);
            }
          )) == null ? void 0 : t.source) ?? "Custom example not found";
        const S = c.value[v.value || ""], d = E(S), K = (d == null ? void 0 : d.value) ?? (d == null ? void 0 : d.summary);
        return l.isWebhook ? ((s = (o = y.value) == null ? void 0 : o.postData) == null ? void 0 : s.text) ?? "" : le({
          clientId: (f = u.value) == null ? void 0 : f.id,
          operation: l.operation,
          method: l.method,
          server: l.selectedServer,
          securitySchemes: l.securitySchemes,
          contentType: l.selectedContentType,
          path: l.path,
          example: K
        });
      } catch (S) {
        return console.error("[generateSnippet]", S), "";
      }
    }), D = i(() => {
      var e;
      return l.isWebhook ? H.value : (e = u.value) == null ? void 0 : e.lang;
    }), H = i(() => {
      var t;
      if (!((t = y.value) != null && t.postData)) return "json";
      const e = y.value.postData.mimeType;
      return e != null && e.includes("json") ? "json" : e != null && e.includes("xml") ? "xml" : e != null && e.includes("yaml") || e != null && e.includes("yml") ? "yaml" : e != null && e.includes("text/plain") ? "text" : "json";
    }), I = i(() => oe(l.securitySchemes)), m = x(null), N = (e) => {
      var t;
      if (m.value) {
        const o = Z(m.value.$el);
        setTimeout(() => {
          o();
        }, 300);
      }
      u.value = e, e.id.startsWith("custom") || w((t = m.value) == null ? void 0 : t.$el, "scalar-update-selected-client", e.id);
    }, z = T();
    return (e, t) => $.value ? (h(), q(a(W), {
      key: 0,
      ref_key: "elem",
      ref: m,
      class: "request-card dark-mode"
    }, {
      default: r(() => [
        n(a(J), { class: "pr-2.5" }, A({
          default: r(() => [
            t[3] || (t[3] = b("span", { class: "sr-only" }, "Request Example for", -1)),
            n(a(R), {
              as: "span",
              class: "request-method",
              method: e.method
            }, null, 8, ["method"]),
            e.generateLabel ? (h(), V("span", {
              key: 0,
              innerHTML: e.generateLabel()
            }, null, 8, se)) : e.isWebhook ? C("", !0) : k(e.$slots, "header", { key: 1 }, void 0, !0)
          ]),
          _: 2
        }, [
          !e.isWebhook && p.value.length ? {
            name: "actions",
            fn: r(() => [
              n(a(P), {
                class: "max-h-80",
                modelValue: u.value,
                options: p.value,
                placement: "bottom-end",
                teleport: "",
                "onUpdate:modelValue": t[0] || (t[0] = (o) => N(o))
              }, {
                default: r(() => [
                  n(a(Q), {
                    class: "text-c-2 hover:text-c-1 flex h-full w-fit gap-1.5 px-0.5",
                    "data-testid": "client-picker",
                    fullWidth: "",
                    variant: "ghost"
                  }, {
                    default: r(() => [
                      b("span", ne, G(u.value.title), 1),
                      n(a(_), {
                        class: "ui-open:rotate-180 mt-0.25 size-3 transition-transform duration-100",
                        weight: "bold"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            key: "0"
          } : void 0
        ]), 1024),
        n(a(j), { class: "request-editor-section custom-scroll p-0" }, {
          default: r(() => [
            b("div", {
              id: `${a(z)}-example`,
              class: "code-snippet"
            }, [
              n(a(X), {
                class: "bg-b-2 !min-h-full -outline-offset-2",
                content: $.value,
                hideCredentials: I.value,
                lang: D.value,
                lineNumbers: ""
              }, null, 8, ["content", "hideCredentials", "lang"])
            ], 8, re)
          ]),
          _: 1
        }),
        Object.keys(c.value).length || e.$slots.footer ? (h(), q(a(Y), {
          key: 0,
          class: "request-card-footer bg-b-3"
        }, {
          default: r(() => [
            Object.keys(c.value).length ? (h(), V("div", ue, [
              n(ae, {
                modelValue: v.value,
                "onUpdate:modelValue": [
                  t[1] || (t[1] = (o) => v.value = o),
                  t[2] || (t[2] = (o) => {
                    var s;
                    return a(w)((s = m.value) == null ? void 0 : s.$el, "scalar-update-selected-example", o);
                  })
                ],
                examples: c.value
              }, null, 8, ["modelValue", "examples"])
            ])) : C("", !0),
            k(e.$slots, "footer", {}, void 0, !0)
          ]),
          _: 3
        })) : C("", !0)
      ]),
      _: 3
    }, 512)) : e.fallback ? (h(), q(a(W), {
      key: 1,
      class: "request-card dark-mode"
    }, {
      default: r(() => [
        n(a(j), { class: "request-card-simple" }, {
          default: r(() => [
            b("div", ie, [
              n(a(R), {
                as: "span",
                class: "request-method",
                method: e.method
              }, null, 8, ["method"]),
              k(e.$slots, "header", {}, void 0, !0)
            ]),
            k(e.$slots, "footer", {}, void 0, !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    })) : C("", !0);
  }
});
export {
  $e as default
};
